var React = require('react');

function Audio (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16.803.048L5.96 6.66H0v9.596h5.959l10.853 6.695-.01-22.904zM5.347 14.55h-3.64V8.368h3.64v6.182zm1.708.377V7.994l8.041-4.906.008 16.804-8.05-4.965z","fill":"#fff","fillRule":"nonzero"}));
}

Audio.defaultProps = {"width":"17","height":"23","viewBox":"0 0 17 23"};

module.exports = Audio;

Audio.default = Audio;
